export default __webpack_public_path__ + "Fascia_5_Dual.png";